import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

export const Container = styled(motion.div)`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 100vh;
    overflow-y: hidden;
    min-width: 320px;
  `}
`

export const Wrapper = styled.div`
  ${({ theme }) => css`
    overflow: auto;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: ${theme.spacing.stack.xxs};
    @media (min-width: 768px) and (max-width: 1170px) {
      padding: ${theme.spacing.stack.sm} ${theme.spacing.stack.xxl};
    }
    @media (min-width: 1171px) {
      padding: ${theme.spacing.stack.sm} ${theme.spacing.stack.xxxl};
    }
  `}
`

export const TextRegister = styled.h1`
  ${({ theme }) => css`
    font-size: ${theme.font.size.md};
    font-weight: ${theme.font.weight.semiBold};
    color: #FFFFFF;
    margin: ${theme.spacing.stack.xxs} 0 ${theme.spacing.stack.xxxs} 0;
    max-width: 212px;
    line-height: ${theme.spacing.stack.sm};
    @media (min-width: 768px) and (max-width: 1170px) {
      max-width: 100%;
      margin: ${theme.spacing.stack.xl} 0 ${theme.spacing.stack.xs} 0;
    }
    @media (min-width: 1171px) {
      display: none;
    }
  `}
`

export const TextObrigatory = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.size.xxs};
    color: ${theme.color.brand.primary.nth2};
    font-weight: ${theme.font.weight.semiBold};

    @media (min-width: 768px) {
      margin-top: ${theme.spacing.stack.xs};
      margin-bottom: ${theme.spacing.stack.xs};
      font-size: ${theme.font.size.sm};
      font-weight: ${theme.font.weight.bold};
    }

    @media (min-width: 1171px) {
      margin-top: ${theme.spacing.stack.sm};
      margin-bottom: ${theme.spacing.stack.xxs};
    }
  `}
`

export const Logo = styled.img`
  ${({ theme }) => css`
    max-width: 200px;
    max-height: 75px;
    margin: 0 auto ${theme.spacing.stack.xxs};
    @media (min-width: 768px) {
      margin: 0 auto ${theme.spacing.stack.md};
    }
  `}
`

export const ContentForm = styled.div`
  ${({ theme }) => css`
    min-width: 272px;
    width: 100%;
    @media (min-width: 768px) {
      min-width: 522px;
      max-width: 522px;
    }
    @media (min-width: 1171px) {
      min-width: 418px;
      max-width: 418px;
    }
  `}
`

export const Form = styled.form`
  ${({ theme }) => css`
    height: 100%;
    width: 100%;
    margin-top: ${theme.spacing.stack.xxs};
    > button {
      margin-top: ${theme.spacing.stack.xxs};
    }
    @media (min-width: 1170px) {
      margin: ${theme.spacing.stack.xs} auto 0 auto;
      max-width: 420px;
      justify-content: center;
    }
  `}
`

export const RulesPassword = styled.div`
  ${({ theme }) => css``}
`

export const RulePassword = styled.p`
  ${({ theme }) => css`
    color: #6c01a3;
    font-size: ${theme.font.size.sm};
    line-height: ${theme.spacing.stack.xxs};
    font-weight: ${theme.font.weight.semiBold};
  `}
`

export const customStyles = {
  clearIndicator: () => ({
    border: '1px solid blue'
  }),
  control: (provided: any) => ({
    ...provided,
    display: 'flex',
    padding: '2px 16px',
    background: 'transparent',
    outline: 'none',
    border: '1px solid #CC92FE',
    boxShadow: 'none',
    borderColor: 'transparent',
    borderRadius: '16px',
  }),
  valueContainer: (provided: any) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    background: 'transparent'
  }),
  indicatorSeparator: (provided: any) => ({
    display: 'none'
  }),
  singleValue: (provided: any) => ({
    color: '#FFFFFF',
    fontSize: '16px',
    lineHeight: '20px'
  }),
  placeholder: (provided: any) => ({
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A'
  }),
  menu: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A',
    borderRadius: '8px',
    background: 'transparent'
  }),
  menuList: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#39383A',
    borderRadius: '8px',
    background: '#080322'
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF',
    backgroundColor: state.isSelected ? 'transparent' : 'transparent'
  }),
  input: (provided: any) => ({
    ...provided,
    fontSize: '16px',
    lineHeight: '20px',
    color: '#FFFFFF'
  })
}

export const Label = styled.p`
  ${({ theme }) => css`
    color: #FFFFFF;
    font-size: ${theme.font.size.sm};
    font-weight: ${theme.font.weight.regular};
    line-height: 24px;
    margin-bottom: 0.5rem;
  `}
`

export const Error = styled.p`
  ${({ theme }) => css`
    color: #fc3e3e;
    font-size: ${theme.font.size.xxs};
    min-height: ${theme.spacing.stack.xxs};
  `}
`

export const ProfileSection = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: ${theme.spacing.stack.sm};
  `}
`

export const ProfileImageContainer = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin-bottom: ${theme.spacing.stack.xxs};
  `}
`

export const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`

export const ProfilePlaceholder = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: ${theme.color.brand.primary.nth2};
    display: flex;
    align-items: center;
    justify-content: center;
  `}
`

export const UserIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: #CC92FE;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z'/%3E%3C/svg%3E") center/contain no-repeat;
`

export const PlusIcon = styled.span`
  &:before {
    content: '+';
    color: white;
    font-size: 24px;
  }
`

export const ImageInput = styled.input`
  display: none;
`

export const AddImageButton = styled.label`
  ${({ theme }) => css`
    position: absolute;
    bottom: 0;
    right: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: ${theme.color.brand.primary.nth2};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: ${theme.color.brand.primary.nth1};

      ${PlusIcon} {
        color: ${theme.color.brand.primary.nth2};
      }
    }
  `}
`

export const InterestsSection = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spacing.stack.sm};
  `}
`

export const InterestsTitle = styled.h2`
  ${({ theme }) => css`
    color: #FFFFFF;
    font-size: ${theme.font.size.lg};
    font-weight: ${theme.font.weight.semiBold};
    margin-bottom: ${theme.spacing.stack.xxs};
  `}
`

export const InterestsSubtitle = styled.p`
  ${({ theme }) => css`
    color: #FFFFFF;
    font-size: ${theme.font.size.sm};
    margin-bottom: ${theme.spacing.stack.sm};
  `}
`

export const InterestsGrid = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: ${theme.spacing.stack.xxs};
    margin-bottom: ${theme.spacing.stack.sm};
  `}
`

export const InterestButton = styled.button<{ selected?: boolean }>`
  ${({ theme, selected }) => css`
    padding: ${theme.spacing.stack.xxs} ${theme.spacing.stack.xs};
    border-radius: 8px;
    border: 1px solid ${theme.color.brand.primary.nth2};
    background-color: ${selected ? 'rgba(108, 1, 163, 0.2)' : 'transparent'};
    color: #FFFFFF;
    font-size: ${theme.font.size.sm};
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background-color: rgba(108, 1, 163, 0.2);
    }
  `}
`
